import {ComponentType} from 'react';

export function getDisplayName<P>(component: ComponentType<P>): string {
  return component.displayName || component.name || 'Component';
}

export function getMostInnerComponentDisplayName<P>(
  component: ComponentType<P>
): string {
  const displayName = component.displayName || component.name || 'Component';
  const parenStartIdx = displayName.lastIndexOf('(') + 1;
  const parenEndIdx = displayName.indexOf(')', parenStartIdx);
  return displayName.substring(
    parenStartIdx,
    parenEndIdx !== -1 ? parenEndIdx : displayName.length
  );
}

export default {getDisplayName, getMostInnerComponentDisplayName};
